export function getDistributorColumnDisplay({
  distributorName,
  selectedDistributors = [],
  distributorOptions = [],
}) {
  const distributorNames = splitDistributorNames(distributorName);
  const selectedNames = getSelectedDistributorNames(
    selectedDistributors,
    distributorOptions,
  );
  const matchedNames = distributorNames.filter((name) =>
    isSelectedDistributorName(name, selectedNames),
  );
  const remainingNames = distributorNames.filter(
    (name) => !isSelectedDistributorName(name, selectedNames),
  );

  return {
    matchedNames,
    remainingNames,
    fallbackText: distributorName,
    hasMatchedNames: matchedNames.length > 0,
  };
}

function splitDistributorNames(distributorName) {
  return String(distributorName || "")
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean);
}

function getSelectedDistributorNames(selectedDistributors, distributorOptions) {
  const selectedValueSet = new Set(
    selectedDistributors.map((value) => String(value)),
  );
  return distributorOptions
    .filter((option) => selectedValueSet.has(String(option.value)))
    .map((option) => option.label)
    .filter(Boolean);
}

function normalizeDistributorName(name) {
  return String(name)
    .trim()
    .toLowerCase();
}

function normalizeDistributorNameWithoutId(name) {
  return normalizeDistributorName(name).replace(/\s*\([^)]*\)\s*$/, "");
}

function isSelectedDistributorName(distributorName, selectedNames) {
  const normalizedDistributorName = normalizeDistributorName(distributorName);
  const normalizedDistributorNameWithoutId =
    normalizeDistributorNameWithoutId(distributorName);

  return selectedNames.some((selectedName) => {
    const normalizedSelectedName = normalizeDistributorName(selectedName);
    const normalizedSelectedNameWithoutId =
      normalizeDistributorNameWithoutId(selectedName);

    return (
      normalizedDistributorName === normalizedSelectedName ||
      normalizedDistributorNameWithoutId === normalizedSelectedNameWithoutId
    );
  });
}
